//jsxhook

import { Modal } from "@sixty-six-north/ui-system"
import React from "react"
import { useTranslation } from "react-i18next"
import { useAllCategoriesLookup } from "../category/CategoryHooks"
import { DomainCategory } from "./models/DomainCategory"
import { SizeGuide, SizeGuideProduct } from "./product/SizeGuide"
import { ModelDetail } from "./VariantProxy"

export const SizeGuideModal: React.FC<{
  categoryKeys: string[]
  onClose: () => void
  show: boolean
  modelDetails: ModelDetail[]
  product: SizeGuideProduct
}> = ({ categoryKeys, onClose, show, product, modelDetails }) => {
  const { t } = useTranslation("product")
  const allCategories = useAllCategoriesLookup()

  // work out what size guide to show mens/unisex, womens or "kids"
  // default to men if we can't find anything
  // long term we need to create a size guide for accessories but the data doesn't exist yet

  const sizeGuideKey = (parentCategories: string) => {
    switch (parentCategories) {
      case "men":
        return "men"
      case "women":
        return "women"
      case "kids":
        return "kids"
      default:
        return "men"
    }
  }

  const sizeGuideCategory = () => {
    // if there is both mens and womens, we assume its unisex and default to mens
    if (categoryKeys.length >= 2) {
      return "men"
    }
    const ancestor = allCategories.categoryLookup(categoryKeys[0])?.ancestors[0]
      ?.key
    if (ancestor) {
      // only one, so check if its mens or womens
      return sizeGuideKey(ancestor)
    } else {
      return "men"
    }
  }

  return (
    <Modal show={show} close={onClose} title={t("sizeGuide")} width={[780]}>
      <SizeGuide
        sizesFor={sizeGuideCategory()}
        product={product}
        modelDetails={modelDetails}
      />
    </Modal>
  )
}
